var _path, _path2, _path3, _path4, _g, _path5, _g2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g3, _path17, _path18, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLines1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 404,
    viewBox: "0 0 260 404",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3324 344.113C20.7353 344.493 21.9837 344.823 23.3268 345.1L15.3867 342.972C16.688 343.404 18.0884 343.78 19.3324 344.113Z",
    fill: "url(#paint0_linear_740_5451)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M142.344 80.8983C128.58 71.2021 112.966 63.764 95.6828 59.1284C78.5517 54.5372 61.1504 53.1306 44.3906 54.6465L142.344 80.8983Z",
    fill: "url(#paint1_linear_740_5451)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90234 63.126L170.724 107.035C167.141 102.65 163.221 98.5972 159.1 94.6548L22.9967 58.1784C17.4642 59.5337 12.0965 61.1845 6.90234 63.126Z",
    fill: "url(#paint2_linear_740_5451)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_740_5451",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -19,
    y: 0,
    width: 206,
    height: 206
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-18.9883 75.4414L111.68 0.000320435L186.633 129.824L55.9654 205.265L-18.9883 75.4414Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_740_5451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-17.9746 74.9874L186.336 129.747C184.268 125.936 181.909 122.298 179.543 118.659L-6.54619 68.7857C-10.4716 70.6555 -14.2782 72.721 -17.9746 74.9874Z",
    fill: "url(#paint3_linear_740_5451)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_740_5451",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -39,
    y: 0,
    width: 237,
    height: 237
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-38.8438 86.9072L111.2 0.27935L197.62 149.964L47.5765 236.592L-38.8438 86.9072Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_740_5451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-36.9303 88.4329L196.034 150.872C194.805 147.369 193.316 143.885 191.732 140.455L-28.0515 81.4678C-31.0831 83.7411 -34.1122 86.0186 -36.9303 88.4329Z",
    fill: "url(#paint4_linear_740_5451)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-52.0557 102.824L201.776 170.852C201.012 167.478 200.21 164.257 199.344 160.936L-44.9319 95.5563C-47.3954 97.8981 -49.8016 100.339 -52.0557 102.824Z",
    fill: "url(#paint5_linear_740_5451)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M-64.1031 118.206L204.524 190.203C204.283 187.049 203.886 183.853 203.492 180.661L-58.4369 110.463C-60.4356 112.933 -62.2736 115.443 -64.1031 118.206Z",
    fill: "url(#paint6_linear_740_5451)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M-73.6179 134.1L204.821 208.719C204.99 205.599 205.062 202.529 205.035 199.516L-69.1982 126.02C-70.7278 128.616 -72.2002 131.311 -73.6179 134.1Z",
    fill: "url(#paint7_linear_740_5451)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M-80.8955 150.675L202.837 226.72C203.375 223.771 203.756 220.787 204.141 217.801L-77.5678 142.306C-78.73 145.08 -79.7906 147.801 -80.8955 150.675Z",
    fill: "url(#paint8_linear_740_5451)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M-84.9785 163.436C-85.3537 164.836 -85.6716 166.336 -86.0443 167.74L198.773 244.073C199.148 242.672 199.623 241.215 200 239.807C200.375 238.407 200.693 236.907 201.068 235.507L-83.7496 159.174C-84.129 160.577 -84.6033 162.035 -84.9785 163.436Z",
    fill: "url(#paint9_linear_740_5451)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M-89.1227 185.441L192.584 260.943C193.744 258.164 194.906 255.39 195.913 252.567L-87.8165 176.526C-88.3004 179.57 -88.738 182.454 -89.1227 185.441Z",
    fill: "url(#paint10_linear_740_5451)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M-90.015 203.731L184.218 277.227C185.748 274.631 187.22 271.936 188.635 269.142L-89.8034 194.523C-89.9702 197.648 -90.0422 200.718 -90.015 203.731Z",
    fill: "url(#paint11_linear_740_5451)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M-88.4737 222.586L173.455 292.784C175.449 290.317 177.333 287.649 179.119 285.038L-89.6052 213.102C-89.3073 216.355 -88.9699 219.448 -88.4737 222.586Z",
    fill: "url(#paint12_linear_740_5451)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M-84.2306 242.249L160.1 307.734C162.568 305.39 164.972 302.945 167.164 300.363L-86.7625 232.389C-86.057 235.671 -85.1934 238.989 -84.2306 242.249Z",
    fill: "url(#paint13_linear_740_5451)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M-76.7129 262.793L143.17 321.722C146.256 319.544 149.131 317.229 152.103 314.852L-80.9579 252.474C-79.6295 255.92 -78.2396 259.462 -76.7129 262.793Z",
    fill: "url(#paint14_linear_740_5451)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_740_5451",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -72,
    y: 197,
    width: 207,
    height: 207
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M-71.5938 273.027L58.9361 197.666L134.106 327.864L3.5764 403.226L-71.5938 273.027Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_740_5451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-64.3693 284.625L121.723 334.502C125.646 332.628 129.452 330.562 133.149 328.296L-71.3203 273.501C-69.1529 277.255 -66.8316 281.047 -64.3693 284.625Z",
    fill: "url(#paint15_linear_740_5451)"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M-44.1434 308.492L92.1165 345.01C97.6559 343.657 103.019 342.008 108.272 340.159L-55.7031 296.213C-52.0233 300.536 -48.2001 304.65 -44.1434 308.492Z",
    fill: "url(#paint16_linear_740_5451)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M-27.3789 322.249C-14.6834 331.24 -0.31068 338.349 15.391 342.972L23.3311 345.1C39.2403 348.949 55.2369 349.983 70.728 348.538L-27.3789 322.249Z",
    fill: "url(#paint17_linear_740_5451)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_740_5451",
    x1: 18.1946,
    y1: 345.146,
    x2: 22.0269,
    y2: 342.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_740_5451",
    x1: 79.0304,
    y1: 81.4643,
    x2: 126.308,
    y2: 54.1537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_740_5451",
    x1: 64.8362,
    y1: 107.979,
    x2: 143.904,
    y2: 62.3043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_740_5451",
    x1: 54.2745,
    y1: 130.906,
    x2: 152.905,
    y2: 73.9305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_740_5451",
    x1: 45.4061,
    y1: 151.445,
    x2: 158.824,
    y2: 85.9276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_740_5451",
    x1: 37.6862,
    y1: 170.961,
    x2: 162.079,
    y2: 99.1029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_740_5451",
    x1: 30.8292,
    y1: 189.847,
    x2: 163.037,
    y2: 113.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_740_5451",
    x1: 24.7665,
    y1: 207.975,
    x2: 162.313,
    y2: 128.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_740_5451",
    x1: 19.3495,
    y1: 225.609,
    x2: 159.977,
    y2: 144.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_740_5451",
    x1: 14.5713,
    y1: 242.633,
    x2: 156.173,
    y2: 160.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_740_5451",
    x1: 10.3807,
    y1: 259.091,
    x2: 151.008,
    y2: 177.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_740_5451",
    x1: 6.83037,
    y1: 274.94,
    x2: 144.377,
    y2: 195.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_740_5451",
    x1: 4.00495,
    y1: 289.978,
    x2: 136.213,
    y2: 213.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_740_5451",
    x1: 2.008,
    y1: 304.32,
    x2: 126.397,
    y2: 232.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_740_5451",
    x1: 0.881057,
    y1: 317.538,
    x2: 114.374,
    y2: 251.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_740_5451",
    x1: 0.999036,
    y1: 329.5,
    x2: 99.6877,
    y2: 272.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_740_5451",
    x1: 2.28463,
    y1: 341.107,
    x2: 81.4278,
    y2: 295.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_740_5451",
    x1: 7.31473,
    y1: 349.107,
    x2: 54.6674,
    y2: 321.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines1);
export default __webpack_public_path__ + "static/media/lines1.66a2d66be29d5251ad9e785aa8d02578.svg";
export { ForwardRef as ReactComponent };